import React from "react";
import { Route, Routes } from "react-router-dom";
import BlockRegister from "../screens/BlockRegister/BlockRegister";
import BlockTurn from "../screens/BlockRegister/BlockTurn/BlockTurn";
import NotFound from "../screens/NotFound";

const BlockRegisterRoutes = () => {
  return (
    //mejorar la logica
    <Routes>
      <Route path="/" element={<BlockRegister />} />
      <Route path="/:blockLetter" element={<BlockTurn />} />
      <Route path="/*" element={<NotFound />} />
    </Routes>
  );
};

export default BlockRegisterRoutes;
